module.exports = __webpack_public_path__ + "icon_people_50gray.88d9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_people_50gray.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_people_50gray.svg
// module chunks = main